import React from 'react'
import { IconButton, Stack, Typography } from '@mui/material'
import { Close } from '@mui/icons-material'

import { useTranslation } from 'react-i18next'

import CurrentCredits from '../CurrentCredits'
import TimeslotSelectionGraphql from '../../TimeslotSelectionGraphql'
import LocationSelectionGraphql from '../../LocationSelectionGraphql'
import { FragmentType, graphql, useFragment } from '@/generated/gql'

const canteenCartHeaderMenuDataFragment = graphql(`
  fragment CanteenCartHeader_MenuDataFragment on CCMealService {
    ...CanteenTimeslotSelection_MenuDataFragment
    ...CanteenCartCurrentCredits_CurrentMenuDataFragment
    timeslots {
      id
      startTime
    }
  }
`)

const canteenCartHeaderUserDataFragment = graphql(`
  fragment CanteenCartHeader_UserDataFragment on User {
    ...CanteenLocationSelection_UserDataFragment
    ...CanteenCartCurrentCredits_UserDataFragment
    account {
      userInterfaceSettings {
        hideCCPrices
      }
    }
  }
`)

type Props = {
  arrivalTime: string
  menuData: FragmentType<typeof canteenCartHeaderMenuDataFragment>
  userData: FragmentType<typeof canteenCartHeaderUserDataFragment>
  onClose: () => void
  onChangeTimeslot: (timeslot: string) => void
}

const Header: React.FC<Props> = ({
  onClose,
  onChangeTimeslot,
  arrivalTime,
  menuData: menuDataProp,
  userData: userDataProp,
}) => {
  const menuData = useFragment(canteenCartHeaderMenuDataFragment, menuDataProp)
  const userData = useFragment(canteenCartHeaderUserDataFragment, userDataProp)
  const { t } = useTranslation()

  return (
    <>
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        justifyContent="space-between"
        padding={1}
        paddingRight={2}
      >
        <IconButton onClick={onClose} data-cy="order-modal-close-button">
          <Close />
        </IconButton>
        <Typography variant="subtitle2">{t('cc:yourOrder')}</Typography>
        {!userData.account?.userInterfaceSettings.hideCCPrices ? (
          <CurrentCredits userData={userData} menuData={menuData} />
        ) : null}
      </Stack>
      <Stack
        bgcolor="background.default"
        padding={1}
        direction={{ xs: 'column', md: 'row' }}
        spacing={1}
      >
        <LocationSelectionGraphql userData={userData} disabled />
        <TimeslotSelectionGraphql
          selectedTimeslot={arrivalTime}
          timeslots={menuData}
          onChangeTimeslot={onChangeTimeslot}
        />
      </Stack>
    </>
  )
}

export default Header
